// extracted by mini-css-extract-plugin
export default {"statusContainer":"ANPOpZ"};